import React, { FC, useEffect, useRef, useState } from "react";
import { useDebouncedCallback } from "@evergis/react";
import { AutoComplete } from "@evergis/ui";

import { FILTER_UPDATE_DEBOUNCE } from "./constants";
import { getConfigFilter } from "../../utils/getConfigFilter";
import { getDataSource } from "../../utils/getDataSource";
import { useWidgetContext } from "../../../Dashboard/hooks/useWidgetContext";
import { WidgetFilterProps } from "./types";

export const TextFilter: FC<WidgetFilterProps> = ({ type, filter, config }) => {
  const { filters, changeFilters, dataSources } = useWidgetContext(type);
  const suggestRef = useRef<HTMLElement | null>(null);
  const updateDebounce = useDebouncedCallback(FILTER_UPDATE_DEBOUNCE);
  // const searchingFor = useRef("");

  const { filters: configFilters } = config;
  const { filterName, placeholder, width, height } = filter.options;
  const filterValue = (filters[filterName]?.value as string) || "";

  const [value, setValue] = useState(filterValue);

  /* const search = useCallback(
    async (searchValue: string) => {
      searchingFor.current = searchValue;

      const response = await fetch([url, searchValue].join(""), fetchSettings);

      if (response.status === 200 && searchValue === searchingFor.current) {
        return response.json().then(data => {
          return data.map(({ text, value: responseValue }: { text: string; value: string }) => ({
            text,
            value: responseValue,
          }));
        });
      }

      return [];
    },
    [fetchSettings, url],
  );*/

  useEffect(() => {
    updateDebounce(() => {
      changeFilters({
        [filterName]: {
          value,
        },
      });
    });
  }, [value]); // eslint-disable-line

  const configFilter = getConfigFilter(filterName, configFilters);

  if (!configFilter) return null;

  const dataSource = getDataSource(configFilter.relatedDataSource, dataSources);
  const options = dataSource?.features?.map(feature => ({
    text: feature.attributes[configFilter.attributeAlias],
    value: feature.attributes[configFilter.attributeValue],
  }));

  return (
    <AutoComplete
      value={value as string}
      placeholder={placeholder}
      options={options}
      zIndex={100}
      width={width ? `${width}px` : "17.25rem"}
      menuHeight={height ? `${height}px` : "10rem"}
      onChange={setValue}
      onGetInnerRef={ref => (suggestRef.current = ref)}
      // asyncCallback={search}
    />
  );
};
